import { combineReducers } from "redux";

import addMoneyReducer from "./slices/AddMoneySlice";
import collectMoneyReducer from "./slices/collectMoneySlice";
import commonReducer from "./slices/commonSlice";
import contactReducer from "./slices/contactSlices";
import customerReducer from "./slices/customerSlice";
import draftRecipientReducer from "./slices/draftRecipientSlices";
import loginReducer from "./slices/loginSlices";
import orderReducer from "./slices/orderSlices";
import paymentMethodsReducer from "./slices/paymentMethodsSlices";
import recipientReducer from "./slices/recipientSlices";
import sendMoneyReducer from "./slices/sendMoneySlices";
import transactionReducer from "./slices/transactionSlices";

const appReducer = combineReducers({
  /* app’s top-level reducers */
  login: loginReducer,
  draftRecipient: draftRecipientReducer,
  order: orderReducer,
  recipient: recipientReducer,
  paymentMethods: paymentMethodsReducer,
  transaction: transactionReducer,
  contact: contactReducer,
  sendMoney: sendMoneyReducer,
  addMoney: addMoneyReducer,
  customer: customerReducer,
  collectMoney: collectMoneyReducer,
  common: commonReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "user/signOutUser/fulfilled") {
    localStorage.removeItem("persist:root");
    state = undefined;
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
